import lowerFirst from 'lodash-es/lowerFirst';
import upperFirst from 'lodash-es/upperFirst';
import { QUOTED_TEXT_text } from 'mk/autogenerated/translations/index.8874d078d3791287e62349b5b63a0edd'
import { nbsp } from 'mk/bazaar/common/entities';
import { reactFilter, TextLike } from 'mk/bazaar/common/filters/utils';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';

export { deboldize, boldize } from 'mk/bazaar/common/filters/boldize';
export { getInlinedImages, removeImageMarks, replaceImageMarks } from 'mk/bazaar/common/filters/images';
export { mdLinkize } from 'mk/bazaar/common/filters/mdLinkize';
export { mentionize } from 'mk/bazaar/common/filters/mentionize';
export { urlize } from 'mk/bazaar/common/filters/urlize';
export { devimeoize, vimeoize } from 'mk/bazaar/common/filters/vimeoize';
export { wpLinkize } from 'mk/bazaar/common/filters/wpLinkize';
export { deyoutubize, youtubize } from 'mk/bazaar/common/filters/youtubize';

type ReactChild = React.ReactChild;

/**
 * Convert all \n chars to <br/> elements
 *
 * @param text
 */
export const linebreaksbr = (text: TextLike) => reactFilter(text, (s: string): ReactChild[] => {
    const lines = s.split(/\r\n|\n|\r/);
    // add <br> between lines
    return lines.reduce((ret, line, idx) => {
        if (idx > 0) {
            ret.push(<br />);
        }
        ret.push(line);
        return ret;
    }, []);
});

/**
 * Converts all spaces to nbsp
 *
 * @param text
 */
export const spacesnbsp = (text: TextLike) => reactFilter(text, (s: string): string[] => {
    const words = s.split(/ /);
    // add <br> between lines
    return words.reduce((ret, word, idx) => {
        if (idx > 0) {
            ret.push(nbsp);
        }
        ret.push(word);
        return ret;
    }, []);
});

const TRIM_RE = /^\s+|\s+$/g;

/**
 * Trims whitespace at beginning and end.
 *
 * @param text
 */
export const trim = (text: TextLike) => reactFilter(text, (s: string): string[] => {
    return [s.replace(TRIM_RE, '')];
});

export const quoted = (text: TextLike) => reactFilter(text, (s: string): ReactChild[] => {
    return [interpolate(QUOTED_TEXT_text, {text: s})];
});

export const upperCaseFirst = (text: TextLike) => reactFilter(text, (s: string): ReactChild[] => {
    return [upperFirst(s)];
});

export const lowerCaseFirst = (text: TextLike) => reactFilter(text, (s: string): ReactChild[] => {
    return [lowerFirst(s)];
});
